import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-271" data-mp="3fz5sgaaeu6ml">
      <div className="mx-auto max-w-6xl" data-id="element-272" data-mp="3b1cl3dxdf6kq">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-273" data-mp="3b0aycc6zsvn6">
          Ezt mondják <em className="text-red-700" data-id="element-274" data-mp="36wmr5um9w22g">a tanárok</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-275" data-mp="31ybg5gk8rlin">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-276" data-mp="2x2w4mv9pi1pe">
              <div className="text-sm text-amber-500" aria-label="5 csillagból 5" data-id="element-277" data-mp="2s306vdrlr6ia">
                <span aria-hidden="true" data-id="element-278" data-mp="v8dnhrk7kmf1">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-279" data-mp="qalko2i0zfw2">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-280" data-mp="h4n4wev9c5ci">
                <span className="font-semibold text-slate-900" data-id="element-281" data-mp="m5kn2rg9oze0">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-282" data-mp="780jnoz0rc9y"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}